import artifact from '$houdini/artifacts/UpdateSettingValue'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateSettingValueStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
